

export const ronReviewerReviewHinge = {
  _id: 'ronReviewerReviewHingeId',
  email: 'ron@email.com',
  profileReviewId: 'ronProfileReviewHingeId',
  reviewerProfileId: 'ronReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Ron! This will really help me!',
  profileReviewedFirstName: 'Hermione',
}

export const dumbledoreReviewerReviewBumble = {
  _id: 'dumbledoreReviewerReviewBumbleId',
  email: 'dumbledore@email.com',
  profileReviewId: 'dumbledoreProfileReviewBumbleId',
  reviewerProfileId: 'dumbledoreReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Dumbledore! This will really help me!',
  profileReviewedFirstName: 'Hermione',
}

export const harryReviewerReviewTinder = {
  _id: 'harryReviewerReviewTinderId',
  email: 'harry@email.com',
  profileReviewId: 'harryProfileReviewTinderId',
  reviewerProfileId: 'harryReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Harry! This will really help me!',
  profileReviewedFirstName: 'Hermione',
}